const news = [
  {
    "image": "./images/banner5.png",
    "header": "Начало 20 сезона!",
    "date": "17 июля 2026",
    "text": "..."
  },
  {
    "image": "./images/banner5.png",
    "header": "Начало 19 сезона!",
    "date": "06 марта 2026",
    "text": "Тестирование новой версии игры — 1.21.11 уже начато!"
  },
  {
    "image": "./images/banner5.png",
    "header": "Начало 18 сезона!",
    "date": "18 июля 2025",
    "text": "Продолжение легендарного сезона Asteria в сеттинге ядерного апокалипсиса!"
  }
];

export function News() {

  return (
    <section className="news">
      <h2>Новости</h2>

      <div className="news-cards">
      {news.map((n, i) => (
        <article key={i} className="news-card">
          <img
            src={n.image}
            alt={n.header}
            draggable="false"
            style={{"borderRadius": "37px"}}
          />
          <div className="news-header">
            <h3>{n.header}</h3>
            <div className="news-date">
              <span>{n.date}</span>
            </div>
          </div>
          <span className="news-text">{n.text}</span>
        </article>
      ))}
      </div>
    </section>
  );
}
